import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomerPartNumberModel } from "@tCooneyBrothers/ApiModels";
import { getCustomerPartNumbers } from "@tCooneyBrothers/Services/CustomerPartNumberService";
import { CustomApiHandler, CustomHandlerWithResult } from "@tCooneyBrothers/Store/CustomHandlerCreator";

export interface AddCpnParameter {
    productId: string;
}

type HandlerType = CustomHandlerWithResult<
    AddCpnParameter,
    {
        apiResult: CustomerPartNumberModel[] | void;
    },
    {}
>;

export const DispatchBeginLoadCustomerPartNumbers: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomerPartNumber/BeginLoadCustomerPartNumbers",
        parameter: props.parameter,
    });
};

// export const PopulateApiParameter: HandlerType = props => {
//     props.apiParameter = { ...props.parameter };
// };

export const RequestDataFromApi: HandlerType = async props => {
    try {
        // eslint-disable-next-line no-console
        props.result = {
            apiResult: await getCustomerPartNumbers(props.parameter.productId),
        };
        // eslint-disable-next-line no-empty
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
};

export const DispatchCompleteLoadCustomerPartNumbers: HandlerType = props => {
    // eslint-disable-next-line no-console
    props.dispatch({
        type: "Data/CustomerPartNumber/CompleteLoadCustomerPartNumbers",
        action: props.result.apiResult || [],
    });
};

export const chain = [
    // PopulateApiParameter,
    DispatchBeginLoadCustomerPartNumbers,
    RequestDataFromApi,
    DispatchCompleteLoadCustomerPartNumbers,
];

const loadCustomerPartNumbers = createHandlerChainRunner(chain, "LoadCustomerPartNumbers");
export default loadCustomerPartNumbers;
